import { render, staticRenderFns } from "./CataloguesList.vue?vue&type=template&id=64066f4e&scoped=true&"
import script from "./CataloguesList.vue?vue&type=script&lang=js&"
export * from "./CataloguesList.vue?vue&type=script&lang=js&"
import style0 from "./CataloguesList.vue?vue&type=style&index=0&id=64066f4e&prod&lang=scss&"
import style1 from "./CataloguesList.vue?vue&type=style&index=1&id=64066f4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64066f4e",
  null
  
)

export default component.exports